import { SavedSearchMessage } from './../../../../misc/saved-searches/models/saved-search.static';
import { WorkflowCurrentDateFields } from './../../../../misc/workflow/models/workflow.static';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Guid } from "guid-typescript";
import { ConfirmationService, MessageService } from "primeng/api";
import { debounceTime, distinctUntilChanged, Subject, takeUntil } from 'rxjs';
import { AccountGroupId } from "src/app/accounts/account.enum";
import { AccountService } from "src/app/accounts/accountService";
import { AppMainService } from "src/app/app-main.service";
import { AppMainComponent } from 'src/app/app.main.component';
import { ConfigurationService } from 'src/app/configurations/configurationService';
import { CrmAccountFieldService } from 'src/app/configurations/crm/account/fields/fields.service';
import { ContactService } from 'src/app/contacts/contactService';
import { getSavedSearchRuleValues, getSavedSearchTreeRuleValues, savedSearchRuleNo } from 'src/app/misc/saved-searches/helpers/get-formated-rules-values.helper';
import { SavedSearchNS } from 'src/app/misc/saved-searches/models/saved-search.models';
import { RatingValueObjects, SavedSearchParentModule } from 'src/app/misc/saved-searches/models/saved-search.static';
import { SavedSearchesService } from 'src/app/misc/saved-searches/services/saved-searches.service';
import { WorkflowModelsNS } from 'src/app/misc/workflow/models/add-update-workflow.models';
import { LeadAccountUpdateFieldSectionsModel, LeadAccountUpdateFieldsModel } from 'src/app/misc/workflow/models/lead-account-update-fields.models';
import { syncColumnSettings } from 'src/app/modules/shared/helpers/sync-column-setting.helper';
import { StatusGroupIds, TypeGroupIds } from '../../constants/category-groupid.constants';
import { FormControlList, FormControlListIds } from '../../constants/formcontrol-list.constants';
import { CUSTOMFIELD_TYPE_IDS } from '../../constants/typeId';
import { FormErrorHandler } from '../../helpers/form-error-handler.helper';
import { getSectionWiseFlatCols } from '../../helpers/section-wise-cols.helper';
import { ChannelN } from "../../models/channel.model";
import { ColumnSettingsN, Fields } from "../../models/column-settings.model";
import { ParseHelper } from '../../parse.helper';
import { SharedColumnSettingsService } from '../../services/column-settings.service';
import { SharedTemplateService } from "../../services/template.service";
import { TimeZoneService } from '../../services/timezone.service';
import { AppRuleSelectionService } from "../rule-selection/app.rule.selection.service";
import { LeadService } from './../../../../leads/leadService';
import { WorkflowService } from './../../../../misc/workflow/services/workflow.service';
import { customFieldTagRegex } from './../../constants/custom-field-tag.regex';
import { AccountModuleId, LeadModuleId } from './../../constants/modules.constant';
import { Status } from './../../models/status';
import { getSavedSearchTableColumns } from 'src/app/misc/saved-searches/helpers/get-saved-search-table-columns.helper';
import { CurrencyService } from '../../services/currency.service';
import { ImportserialService } from '../../services/importserial.service';
@Component({
    selector: 'app-shared-mass-edit',
    styleUrls: ['./shared-mass-edit.component.scss'],
    templateUrl: './shared-mass-edit.component.html',
})
export class SharedMassEditComponent implements OnInit, OnDestroy {

    @Input() displayMassEdit: boolean = false;
    @Input() selectedChannel: ChannelN;
    @Input() selectedModuleId: number = AccountModuleId;
    @Input() selectedModuleName: string = 'Account';
    @Output() closeDialog = new EventEmitter();

    protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    popupHeader: string = "Mass Edit";
    activeIndex = 0;

    selectedModule: SavedSearchNS.IObjectType;
    selectedTemplate: SavedSearchNS.ITemplate;

    pageIndex: number = 1;
    tableShowMore: number[] = [15, 30, 50, 100];
    ruleOption = [{ label: 'Rule Logic', value: 'rule' }, { label: 'Manually', value: 'manually' }];
    selectedRuleOption: string = "rule";

    //Manuall Selection
    displayManualPopup: boolean = false;
    selectedAccounts: any[] = [];
    manualRuleColumnSetttings: Partial<ColumnSettingsN> = {};
    selectedRecordList: any[] = [];
    accountColLists: Fields[] = [];

    //Rules Selection

    tempLastRuleValues = {
        selectedFilter: null,
        selectedOperator: null,
        selectedValue: null,
        selectedValue2: null,
        selectedChoice: { id: 1, name: "And" },
        selectedDataTypeWithOperator: null,
        allEnumMultiselect: [],
        treeSelectData: [],
        selectedGroupLabel: "",
        selectedGroupChildren: "",
        selectedGroup: true,
        filtersDD: [],
        filtersDDTree: []
    };

    lastRuleValues = ParseHelper.DeepCopy(this.tempLastRuleValues);
    ruleData: SavedSearchNS.IRuleList[] = [];
    ruleList: SavedSearchNS.IRuleList[] = [];

    conditionGroup: WorkflowModelsNS.WorkflowAddedEditConditionGroup;
    conditionTemp: WorkflowModelsNS.WorkflowAddedEditConditionGroup;
    actionType: 'instant' | 'timedependent' = 'instant';
    displayParentNewRule: boolean = false;

    selectedEditedRule: SavedSearchNS.IRuleList = null;
    selectedRuleIndex: number = -1;
    displayEditRule: boolean = false;

    //Mass Edit Form
    massEditFieldsForm: FormGroup = new FormGroup({});
    isUnsavedData: boolean = false;
    detailsFormErrors: any = {};
    formErrorHandler: FormErrorHandler = new FormErrorHandler();
    formErrorHandlerList: FormErrorHandler[] = [];
    fieldsFormErrors: any = [];

    customFieldIds = CUSTOMFIELD_TYPE_IDS;
    currentColList: LeadAccountUpdateFieldSectionsModel[] = [];
    hiddenFields: string[] = [
        'sequenceNumber','phone','contactEmail',
        'contactname','contactFirstName','contactMiddleName','contactLastName',
        'social','businessName','work','mainCustomer',
        'name','forcastCategory','probability',
        'createdDate','createdByUserName','updatedDate','updatedByUserName',
        'previousStageOwner', 'stageChangedBy','previousStage','stageChangedDate','contactSequenceNumber'
    ];
    hiddenChildFields: string[] = ['contactEmail', 'phone'];
    availableFields: SavedSearchNS.IField[] = [];
    availableFieldsForExpression: SavedSearchNS.IField[] = [];
    accountModuleId = AccountModuleId;
    leadModuleId = LeadModuleId;
    operationTypes: {id: number, name: string}[] = [
        {id: WorkflowModelsNS.WorkflowUpdateFieldOperationType.Update, name: 'Replace'},
        {id: WorkflowModelsNS.WorkflowUpdateFieldOperationType.Append, name: 'Append'},
        {id: WorkflowModelsNS.WorkflowUpdateFieldOperationType.Remove, name: 'Remove'}
    ];

    historySearchControl = new FormControl();
    historySearchValue: string = "";
    historyRefresh: boolean = false;
    //Mass Edit Workflow
    loadingWorkflowSave: boolean = false;

    //Saved Search Preview
    displaySSPreviewDataList: boolean = false;
    ssPreviewDataList: any[] = []
    ssPreviewColumnList: SavedSearchNS.ISavedSearchPreviceColumnModel[] = [];

    //Add Expression
    displayAddExpression: boolean = false;
    expressionText: string = "";

    mergeAccountSequenceNumber: boolean = false;
    showEncryptedText: boolean = false;
    currencySymbol: string = "";
    //decimal fractiondigits
    maximumFractionDigits: number = 2;

    constructor(
        public app: AppMainComponent,
        private formBuilder: FormBuilder,
        private columnSettingsService: SharedColumnSettingsService,
        private confirmationService: ConfirmationService,
        private messageService: MessageService,
        private appMainService: AppMainService,
        private sharedTemplateService: SharedTemplateService,
        private ruleService: AppRuleSelectionService,
        private savedSearchesService: SavedSearchesService,
        private leadService: LeadService,
        private accountService: AccountService,
        private configService: ConfigurationService,
        private fieldService: CrmAccountFieldService,
        private contactService: ContactService,
        private workflowService: WorkflowService,
        private timezoneService: TimeZoneService,
        private currencyService: CurrencyService,
        private importserialService: ImportserialService,
    ) {
        this.currencySymbol = this.currencyService.currencySymbolValue;
     }

    ngOnInit(): void {
        this.setFractionDigits();
        this.popupHeader = `${this.selectedModuleName} Mass Edit`;
        this.selectedModule = {
            id: this.selectedModuleId,
            name: this.selectedModuleName,
            objectId: this.selectedModuleId,
            isMainModule: true,
            statusId: 1,
            childobject: []
        }

        this.selectedTemplate = {
            id: this.selectedChannel.id,
            templateName: this.selectedChannel.name,
            channelId: this.selectedChannel.id,
            channelName: this.selectedChannel.name,
            isActive: true,
            objectId: this.selectedModuleId
        }

        this.conditionGroup = {
            id: 1,
            conditionId: 0,
            statusId: 1,
            type: 'manual',
            validData: false,
            errorMsg: "",
            savedSearchId: 0,
            isCombinational: false,
            ruleCombination: "",
            ruleData: [],
            instantActions: {
                id: 0,
                workflowConditionId: 0,
                workflowActionType: WorkflowModelsNS.OccurrenceTypeEnum.INSTANT,
                order: 1,
                statusId: 1,
                occurrenceType: WorkflowModelsNS.OccurrenceTypeEnum.INSTANT,
                dateTimeFieldName: 'ExecutionDateTime',
                executionOrders: ParseHelper.DeepCopy(WorkflowModelsNS.WorkflowActionDefaultOrders),
                workflowActionTasks: [],
                workflowActionEmails: [],
                workflowActionUpdateFields: [],
                workflowActionCreateRecords: [],
                workflowActionUpdateRecords: []
            },
            timeDependentActions: []
        }
        this.mergeAccountSequenceNumber = !!(this.selectedModuleId==AccountModuleId);
        this.initMassEditForm();
        this.getTemplateFields();
        this.initHistorySearch();
    }


    setFractionDigits(){
        this.importserialService.getDecimalValue().subscribe(value=>{
            this.maximumFractionDigits = value||this.maximumFractionDigits;
        });
    }

    //#region ***Mass Edit Form***
    initMassEditForm() {
        this.detailsFormErrors = {};
        this.isUnsavedData = false;
        this.massEditFieldsForm = this.formBuilder.group({
            fields: this.formBuilder.array([this.initFieldForm()], [Validators.required]),
        });

        this.formErrorHandler.handleErrors(this.massEditFieldsForm, this.detailsFormErrors, {
            fields: {
                required: "Select any fields to continue",
            }
        });

        this.setFieldsFormErrorMessage();
    }

    initFieldForm() {
        const list = [];
        return this.formBuilder.group({
            id: [0],
            dropdownValues: [list],
            selectedField: [null, [Validators.required]],
            operationType: [WorkflowModelsNS.WorkflowUpdateFieldOperationType.Update],
            fieldDataType: ["String"],
            fieldValueType: [WorkflowModelsNS.WorkflowUpdateFieldValueType.Value],
            addedFieldTags: [null],
            newValue: ["", [Validators.required]],
        });
    }

    setFieldsFormErrorMessage() {
        this.fieldsFormErrors = [];
        this.formErrorHandlerList = [];
        this.getMassEditFields(this.massEditFieldsForm).map((fieldsForm: FormGroup, itemIndex: number) => {

            this.formErrorHandlerList[itemIndex] = new FormErrorHandler();

            Object.defineProperty(this.fieldsFormErrors, itemIndex, { value: {}, writable: true })

            this.formErrorHandlerList[itemIndex].handleErrors(fieldsForm, this.fieldsFormErrors[itemIndex], {
                name: {
                    required: "Enter Name",
                },
                selectedField: {
                    required: "Select Field",
                },
                newValue: {
                    required: "Enter new value"
                }
            });
        })
    }

    getMassEditFields(form) {
        return form.controls?.fields.controls;
    }

    get massEditFields() {
        return this.massEditFieldsForm.get("fields") as FormArray;
    }

    addField() {
        const control = <FormArray>this.massEditFieldsForm.get('fields');
        control.push(this.initFieldForm());
        this.setFieldsFormErrorMessage();
    }

    removeField(index: number) {
        const control = <FormArray>this.massEditFieldsForm.get('fields');
        if (control.length > 1) {
            control.removeAt(index);
            this.setFieldsFormErrorMessage();
        }
    }

    nextPage(){
        if(this.conditionGroup?.ruleData.length>0 || this.selectedAccounts?.length>0){
            this.pageIndex = 2;
        }
    }

    saveMassEdit(){
        if (this.massEditFieldsForm.invalid) {
            this.formErrorHandler.showErrorOnSubmit();
            this.formErrorHandlerList.map(formErrorHandler=>{ formErrorHandler.showErrorOnSubmit() });
            this.scrollToError();
            return; //Return if form invalid
        }

        const uniqueName = Guid.create();
        const triggerType = WorkflowModelsNS.TriggerTypeEnum.MASS_EDIT
        const minimumDate = this.timezoneService.showDateTimeWithZone(new Date());
        const startDate = this.timezoneService.saveDateTimeWithZone(minimumDate).toISOString();
        const endDate = null;

        const workflowData: WorkflowModelsNS.WorkflowAddEditDetails = {
            id: 0,
            organizationId: this.app.user.organizationId,
            sequenceNumber: null,
            name: uniqueName.toString(),
            objectId: this.selectedModule.objectId,
            objectName: this.selectedModule.name,
            channelId: this.selectedTemplate.channelId,
            channelName: this.selectedTemplate.channelName,
            description: `${this.selectedModuleName} Mass Edit`,
            triggerType: triggerType,
            occurrenceType: WorkflowModelsNS.WorkflowScheduleTypesEnum.None,
            occurrenceBase: 5,
            occurrenceValue: 1,
            statusId: 1,
            executionStatus: WorkflowModelsNS.WorkflowExecutionStatus.Pending,
            validFromDate: startDate,
            validToDate: endDate,
            jobId: null,
            lastEndDate: null,
            lastStartDate: null,
            lastSuccessDate: null,
            workflowPermissions: [{
                id: 0,
                workflowId: 0,
                userId: this.app.userId,
                userName: this.app.user?.userName,
                statusId: 1
            }],
            workflowConditions: [],
            accountChannelId: null,
            accountChannelName: null
        }

        const conditionData: WorkflowModelsNS.WorkflowAddEditCondtions = {
            id: 0,
            workflowId: 0,
            isMannualCondition: true,
            saveSearchId: 0,
            order: 1,
            description: "",
            statusId: 1,
            savedSearch: null,
            savedSearchUpdate: null,
            actionIds: [],
            workflowActions: []
        }

        if(this.selectedAccounts?.length>0){
            conditionData.actionIds = this.selectedAccounts.map(account=> account.id);
        }else{
            conditionData.savedSearch = this.prepareNewSaveSearch(this.conditionGroup.ruleData,this.conditionGroup);
        }

        const fieldAction = this.prepareUpdateFieldsAction();
        conditionData.workflowActions.push(fieldAction);
        workflowData.workflowConditions.push(conditionData);

        // console.log(workflowData);

        this.confirmationService.confirm({
            message: "This action cannot be undone. Are you sure you want to proceed?",
            header: "Confirm to Proceed",
            icon: 'pi pi-info-circle',
            accept: () => {
                this.loadingWorkflowSave = true;
                this.appMainService.isShowSpinner('SaveNewWorkflow');
                this.workflowService.addNewWorkflow(workflowData).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
                    next: (workflowId)=>{
                        this.appMainService.isHideSpinner('SaveNewWorkflow');
                        this.loadingWorkflowSave = false;
                        if(workflowId){
                            this.runMassEdit(workflowId);
                        }else{
                            this.messageService.add({ severity: 'error', summary: "Account MassEdit", detail: "Failed to process account MassEdit, please try again." });
                        }
                    },
                    error: (error)=>{
                        this.appMainService.isHideSpinner('SaveNewWorkflow');
                        this.loadingWorkflowSave = false;
                        this.messageService.add({ severity: 'error', summary: "Account MassEdit", detail: "Failed to process account MassEdit, please try again." });
                    }
                })
            },
            reject: () => { }
        });
    }

    runMassEdit(workflowId: number){
        this.loadingWorkflowSave = true;
        this.appMainService.isShowSpinner('RunWorkflow');
        this.workflowService.runNowWorkflowScheduler(workflowId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
            next: (response) => {
                this.appMainService.isHideSpinner('RunWorkflow');
                this.loadingWorkflowSave = false;
                this.messageService.add({ severity: 'success', summary: "Account MassEdit", detail: "MassEdit is in process, check back soon!" });
                this.closeMassEditDialog();
            },
            error: (error) => {
                this.appMainService.isHideSpinner('RunWorkflow');
                this.loadingWorkflowSave = false;
                this.messageService.add({ severity: 'error', summary: "Account MassEdit", detail: "Failed to process account MassEdit, please try again." });
            }
        })
    }

    prepareUpdateFieldsAction(){
        const workflowFieldsAction: WorkflowModelsNS.WorkflowAddEditActions = {
            id: 0,
            workflowConditionId: 0,
            workflowActionType: WorkflowModelsNS.OccurrenceTypeEnum.INSTANT,
            order: 1,
            statusId: 1,
            occurrenceType: WorkflowModelsNS.OccurrenceTypeEnum.INSTANT,
            occurrenceBase: WorkflowModelsNS.WorkflowOccurrenceTypsEnum.Days,
            dateTimeFieldName: 'ExecutionDateTime',
            workflowActionUpdateFields: []
        }

        this.massEditFieldsForm.value.fields.map(fieldDetailsValue=>{
            const selectedField: SavedSearchNS.IField = fieldDetailsValue.selectedField;

            let fieldValue: any = this.setEmptyValue(fieldDetailsValue.newValue,selectedField);

            if(fieldValue!==null && fieldValue!=="" && !['String','Date','DateTime'].includes(fieldDetailsValue?.fieldDataType)){
                fieldValue = JSON.stringify(fieldValue);
            }

            if(fieldDetailsValue?.fieldDataType=='Date' && fieldValue){
                const date: Date = fieldValue;
                fieldValue = date.toLocaleDateString();
            }else if(fieldDetailsValue?.fieldDataType=='DateTime' && fieldValue){
                fieldValue = this.timezoneService._getCustomDateTimeString(fieldValue);
            }

            const fieldData: WorkflowModelsNS.WorkflowAddEditActionUpdateFields = {
                id: 0,
                statusId: 1,
                workflowActionId: 0,
                objectId: this.selectedModule.objectId,
                objectName: this.selectedModule.name,
                fieldName: selectedField.field,
                labelName: selectedField.labelname,
                isCustom: selectedField.custom,
                formControlId: selectedField.formControlId,
                maxLengthAfterDecimal: selectedField?.maxLengthAfterDecimal||null,
                operationType: fieldDetailsValue?.operationType||WorkflowModelsNS.WorkflowUpdateFieldOperationType.Update,
                fieldDataType: fieldDetailsValue?.fieldDataType||'String',
                fieldValueType: fieldDetailsValue?.fieldValueType||WorkflowModelsNS.WorkflowUpdateFieldValueType.Value,
                fieldValue: fieldValue,
                workflowUpdateFieldExpressionFields: [],
                currencySymbol: selectedField?.currencySymbol||null
            }

            if(fieldData.fieldValueType==WorkflowModelsNS.WorkflowUpdateFieldValueType.Expression && fieldDetailsValue.addedFieldTags?.length>0){

                fieldDetailsValue.addedFieldTags.map((labelName, index) =>{
                    const exist = this.availableFieldsForExpression.find(field=>field.labelname==labelName);
                    if(exist){
                        fieldData.workflowUpdateFieldExpressionFields.push({
                            id: 0,
                            workflowActionUpdateFieldId: 0,
                            fieldName: exist.field,
                            labelName: exist.labelname.trim(),
                            statusId: 1,
                            isCustom: exist.custom,
                            objectId: exist?.objectId,
                            objectName: exist?.objectName,
                            displayOrder: index,
                        })
                    }
                })
            }

            workflowFieldsAction.workflowActionUpdateFields.push(fieldData);
        })

        return workflowFieldsAction;
    }

    setEmptyValue(fieldValue, selectedField: SavedSearchNS.IField){
        if(fieldValue!==0 && !fieldValue){
            if ([this.customFieldIds.DATE_PICKER,this.customFieldIds.DATETIMEPICKER, this.customFieldIds.MULTISELECT, this.customFieldIds.CHECKBOX, this.customFieldIds.FILE,
                this.customFieldIds.PICTURE].includes(selectedField.formControlId)) {
                fieldValue = "";
            }else if ([this.customFieldIds.DROPDOWN, this.customFieldIds.RATING, this.customFieldIds.RADIO_BUTTON, this.customFieldIds.NUMBER,this.customFieldIds.DECIMAL].includes(selectedField.formControlId)) {
                fieldValue = null;
            }
        }

        if(fieldValue===0 && selectedField.formControlId==this.customFieldIds.RATING){
            fieldValue = null;
        }

        if(([this.customFieldIds.MULTISELECT, this.customFieldIds.CHECKBOX].includes(selectedField.formControlId) && fieldValue?.length==0)){
            fieldValue = "";
        }

        return fieldValue;
    }

    //Saved-Searche Preview
    previewSavedSearch(): void {
        //Prepare saved-search object
        const type: 'Save' | 'Preview' = 'Preview';
        const newSavedSearches = this.prepareNewSaveSearch(this.conditionGroup.ruleData,this.conditionGroup,type);
        const mainRuleExist = newSavedSearches?.savedSearchRuleRequest?.find(x => x.isMainModule == true);
        // console.log(newSavedSearches);
        // return
        if (mainRuleExist) {
            this.appMainService.isShowSpinner('SaveNewSavedSearch');
            this.savedSearchesService.addSavedSearch(newSavedSearches).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(res => {
                this.appMainService.isHideSpinner('SaveNewSavedSearch');
                if (type == 'Preview') {
                    this.preparePreviewDataList(res);
                }
            },
            error => {
                this.appMainService.isHideSpinner('SaveNewSavedSearch');
                if (type != 'Preview') {
                    this.messageService.add({ severity: SavedSearchMessage.error.toLowerCase(), summary: SavedSearchMessage.error, detail: SavedSearchMessage.saveSearchaveErrorMsg });
                }
            });
        }
        else {
            this.messageService.add({ severity: SavedSearchMessage.warning.toLowerCase(), summary: SavedSearchMessage.warning, detail: 'At least 1 parent rule must be added.' });
        }
    }

    //Prepare Preview Data List
    preparePreviewDataList(res: any) {
        this.displaySSPreviewDataList = true;
        // let previewColumnList: SavedSearchNS.ISavedSearchPreviceColumnModel[] = [];
        if (res?.Result) {
            this.ssPreviewDataList = res?.Result;
            this.ssPreviewColumnList = getSavedSearchTableColumns(res?.savedSearchColumnSetting ?? []) ?? [];
        }
    }

    onSSPreviewCancel(): void {
        this.ssPreviewDataList = [];
        this.ssPreviewColumnList = [];
        this.displaySSPreviewDataList = false;
    }

    prepareNewSaveSearch(ruleData: SavedSearchNS.IRuleList[],conditionGroup: WorkflowModelsNS.WorkflowAddedEditConditionGroup, type: 'Save' | 'Preview' = 'Save'): SavedSearchNS.NewSavedSearches {

        const uniqueName = Guid.create();

        let newSavedSearches: SavedSearchNS.NewSavedSearches = {
            createdSource: this.app.userIP,
            updatedSource: this.app.userIP,
            name: uniqueName.toString(),
            description: "",
            moduleId: this.selectedModule?.objectId,
            channelId: this.selectedTemplate?.channelId,
            accountChannelId: null,
            isCombinational: conditionGroup?.isCombinational||false,
            ruleCombination: conditionGroup?.ruleCombination||"",
            statusId: 1,
            isPreview: type == 'Preview' ? true : false,
            previewId: 0,
            savedSearchRuleRequest: [],
            savedSearchUserPermissionRequest: [],
        };

        let savedSearchRule: SavedSearchNS.SavedSearchRuleRequest[] = [];
        let sequenceOrder = 0;
        ruleData.forEach(rule => {
            sequenceOrder += 1;
            const { values, valueRefId } = getSavedSearchRuleValues(rule);
            savedSearchRule.push(
                {
                    id: 0,
                    ruleNo: rule?.ruleNo,
                    createdSource: this.app.userIP,
                    updatedSource: this.app.userIP,
                    savedSearchId: 0,
                    objectId: rule.module.objectId,
                    objectName: rule.module.name,
                    isMainModule: rule.isMainModule,
                    criteria: rule.filter.custom ? rule.filter.name : rule.filter.field.charAt(0).toUpperCase() + rule.filter.field.slice(1),//UpperCase First Later
                    equation: rule.operator.name,
                    values: values,
                    valueRefId: valueRefId,
                    operator: rule.choice?.name||null,
                    isCustom: rule.filter.custom,
                    dataType: rule.filter.fieldDataType,
                    statusId: 1,
                    sequenceOrder: sequenceOrder,
                    templateId: rule.template.id,
                    templateName: rule.template.templateName,
                    labelName: null,
                    parentLabelName: null,
                    accountChannelId: null,
                    compareWithField: rule?.compareWithField||false,
                    comparisonCriteria: rule?.comparisonCriteria||null,
                    customAttributeObjectId: null,
                    comparisonCustomAttributeObjectId: null,
                    comparisonCriteriaLabel: rule?.comparisonCriteriaLabel||null,
                    comparisonCriteriaParentLabel: rule?.comparisonCriteriaParentLabel||null,
                    isCustomComparisonCriteria: rule?.isCustomComparisonCriteria||false,
                    comparisonCriteriaObject: rule?.comparisonCriteriaObject||null
                }
            );
        });
        newSavedSearches.savedSearchRuleRequest = savedSearchRule;

        //UserPermission
        newSavedSearches.savedSearchUserPermissionRequest = [{ id: 0, savedSearchId: 0, userId: this.app.userId, userName: this.app.user.userName, statusId: 1 }];
        return newSavedSearches;
    }


    //#endregion

    //#region ***Dropdown Values***
    getTemplateFields() {
        this.appMainService.isShowSpinner('getColumnSettings');
        this.sharedTemplateService.getTemplateSectionsForFormBuild(this.selectedModule.objectId, this.selectedTemplate?.id).subscribe(
            {
                next: (response) => {
                    this.currentColList = response || [];
                    this.currentColList.map((fields, i) => [
                        fields.customFields.map((customFields, i) => {
                            const formControlDetails: any = ParseHelper.DeepCopy(customFields.formControl);
                            customFields = {
                                ...customFields,
                                formControl: formControlDetails?.type,
                                formControlDetails: formControlDetails,
                                isCustom: true
                            }

                            fields.customFields[i] = customFields;
                        })
                    ]);
                    this.generateAvailableFields();
                    this.appMainService.isHideSpinner('getColumnSettings');
                },
                error: (error) => {
                    this.appMainService.isHideSpinner('getColumnSettings');
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: error?.error?.message ? error?.error?.Message : 'Column Settings are not loaded, please try again...'
                    });
                },
                complete: () => {

                },
            });
    }

    generateAvailableFields(){
        this.availableFields = [];
        this.availableFieldsForExpression = [...WorkflowCurrentDateFields];
        this.currentColList.map(sectionDetails=>{
            if(!sectionDetails?.systemGenerated || sectionDetails.name.toLowerCase().includes('information') || (sectionDetails.name.toLowerCase().includes('details') && !sectionDetails.name.toLowerCase().includes('address'))){
                sectionDetails.fields.filter(f=> !this.hiddenChildFields.includes(f.field)).map(field=>{
                    if(field?.childFields?.length>0){
                        field.childFields.map(childField=>{
                            this.setFieldDetails(childField);
                        })
                    }else{
                        this.setFieldDetails(field);
                    }
                });

                sectionDetails.customFields.map(field=>{
                    this.setFieldDetails(field);
                });
            }
        });
    }

    setFieldDetails(fieldDetails: LeadAccountUpdateFieldsModel){
        if(fieldDetails?.field && fieldDetails?.mapObject!='opportunityProduct' && !this.hiddenFields.includes(fieldDetails.field) &&
            ![FormControlList.FileUpload,FormControlList.Picture,FormControlList.EncryptedText,FormControlList.AutoNumber,FormControlList.Formula].includes(fieldDetails.formControl)
        ){
            const alwaysRequiredFields = ['stagename','currentstage','classificationame'];
            const isRequried: boolean = (alwaysRequiredFields.includes(fieldDetails.field.toLowerCase()) || fieldDetails?.isRequired);
            const field: any = {
                id: fieldDetails.id,
                labelname: this.getFormatedName(fieldDetails),
                name: fieldDetails.name,
                code: fieldDetails.field,
                isrequired: isRequried,
                ischecked: true,
                isShowInSetting: true,
                isDuplicate: true,
                isGlobalSearch: true,
                width: "",
                movable: false,
                showForDrag: false,
                templateId: this.selectedTemplate?.id || 0,
                sectionId: 0,
                custom: fieldDetails?.isCustom||false,
                formControlId: fieldDetails?.formControlDetails?.id||FormControlListIds[fieldDetails.formControl],
                formControl: fieldDetails.formControl,
                expression: fieldDetails?.formControlDetails?.expression,
                pickListValues: fieldDetails?.formControlDetails?.pickListValues||[],
                maxLengthAfterDecimal: fieldDetails?.formControlDetails?.maxLengthAfterDecimal||null,
                field: fieldDetails.field,
                mapObject: "",
                isColumnSetting: true,
                value: "",
                displayOrder: 0,
                fieldTypes: null,
                fieldDataType: "String",
                valueDataType: "String",
                operators: [],
                operatorsDD: [],
                currencySymbol: fieldDetails?.currencySymbol || null
            }

            this.availableFields.push(field);

            if([FormControlList.Number,FormControlList.Decimal].includes(fieldDetails.formControl)){
                this.availableFieldsForExpression.push(field);
            }
        }
    }

    getFormatedName(fieldDetails: LeadAccountUpdateFieldsModel) {
        let labelName = fieldDetails.labelName;

        if (fieldDetails.mapObject == 'leadSocial') {
            labelName = `Lead ${fieldDetails.labelName}`
        }

        if (fieldDetails.mapObject == 'accountSocial') {
            labelName = `Account ${fieldDetails.labelName}`
        }

        return labelName;
    }

    selectField(fieldDetailsForm: FormGroup) {
        this.setSectionCustomPayload(fieldDetailsForm);
        this.getFieldChangeValue(fieldDetailsForm);
    }

    setSectionCustomPayload(fieldDetailsForm: FormGroup) {
        const selectedField: SavedSearchNS.IField = fieldDetailsForm.value.selectedField;

        if (selectedField.formControlId) {

            const formControlId: number = selectedField.formControlId;
            let newValue: any = "";
            let dataType: string = "String";

            if (formControlId === this.customFieldIds.CHECKBOX) {
                newValue = [];
                dataType = 'Array';
            } else if (formControlId === this.customFieldIds.TOOGLE_BUTTON) {
                newValue = false;
                dataType = 'Boolean';
            } else if (formControlId === this.customFieldIds.DATE_PICKER) {
                newValue = null;
                dataType = 'Date';
            } else if (formControlId === this.customFieldIds.DATETIMEPICKER) {
                newValue = null;
                dataType = 'DateTime';
            } else if (formControlId === this.customFieldIds.DROPDOWN || formControlId === this.customFieldIds.USERLOOKUP) {
                newValue = null;
                dataType = 'Object';
            } else if (formControlId === this.customFieldIds.MULTISELECT) {
                newValue = null;
                dataType = 'Array';
            } else if (formControlId === this.customFieldIds.RATING) {
                newValue = 0;
                dataType = 'Number';
            } else if (formControlId === this.customFieldIds.FILE || formControlId === this.customFieldIds.PICTURE) {
                newValue = null;
                dataType = 'File';
            } else if (formControlId === this.customFieldIds.INPUT) {
                newValue = "";
                dataType = 'String';
            } else if (formControlId === this.customFieldIds.NUMBER || formControlId === this.customFieldIds.DECIMAL) {
                newValue = null;
                dataType = 'Number';
            } else if (formControlId === this.customFieldIds.RADIO_BUTTON) {
                newValue = null;
                dataType = 'String';
            } else {
                newValue = null;
                dataType = 'String';
            }

            fieldDetailsForm.patchValue({
                newValue: newValue,
                fieldDataType: dataType,
                operationType: WorkflowModelsNS.WorkflowUpdateFieldOperationType.Update
            });

            const newValueControl = fieldDetailsForm.get('newValue');
            const validations = [];

            if(selectedField?.isrequired){
                validations.push(Validators.required);
            }

            if(selectedField?.expression && [this.customFieldIds.DATETIMEPICKER, this.customFieldIds.DECIMAL, this.customFieldIds.NUMBER].includes(formControlId)){
                validations.push(Validators.pattern(selectedField?.expression));
            }

            newValueControl.setValidators(validations);
            newValueControl.updateValueAndValidity();
        }
    }

    getFieldChangeValue(fieldDetailsForm: FormGroup, selectedValues: any = null) {
        // console.log(field)
        //****Custom Field */
        const field: SavedSearchNS.IField = fieldDetailsForm.value.selectedField;
        if (field.custom == true) {
            if (
                // field.fieldDataType == 'Enum' ||
                field?.formControlId == CUSTOMFIELD_TYPE_IDS.MULTISELECT ||
                field?.formControlId == CUSTOMFIELD_TYPE_IDS.DROPDOWN ||
                field?.formControlId == CUSTOMFIELD_TYPE_IDS.CHECKBOX ||
                field?.formControlId == CUSTOMFIELD_TYPE_IDS.RADIO_BUTTON) {
                let custompickvalues = [];
                let typescustom = [];
                typescustom = ParseHelper.DeepCopy((field?.pickListValues || []));
                for (let name of typescustom) {
                    let eachType = {
                        name: name
                    }
                    if (typeof name == 'object') {
                        eachType = name;
                    }
                    custompickvalues.push(eachType);
                }

                fieldDetailsForm.patchValue({
                    dropdownValues: custompickvalues
                })
            } else if (field?.formControlId == CUSTOMFIELD_TYPE_IDS.USERLOOKUP) {
                this.getUsersList(fieldDetailsForm, selectedValues);
            } else if (field?.formControlId == CUSTOMFIELD_TYPE_IDS.RATING) {
                let custompickvalues = RatingValueObjects;
                fieldDetailsForm.patchValue({
                    dropdownValues: custompickvalues
                })
            }
        }
        else {
            fieldDetailsForm.patchValue({
                dropdownValues: []
            })
            if (['salesrep', 'owner','ownername','currentstageowner'].includes(field.field?.toLowerCase())) {
                this.getUsersList(fieldDetailsForm, selectedValues);
            } else if (field.field?.toLowerCase() == "accounttypesname") {
                this.getAllAccountTypes(fieldDetailsForm, selectedValues);
            } else if (field.field?.toLowerCase() == "sourcename") {
                if (this.selectedModule.name.toLowerCase() == SavedSearchParentModule.Lead?.toLowerCase()) {
                    this.getAllLeadSource(fieldDetailsForm, selectedValues);
                }
                else if (this.selectedModule.name.toLowerCase() == SavedSearchParentModule.Account?.toLowerCase()) {
                    this.getAllAccountSource(fieldDetailsForm, selectedValues);
                }
            } else if (field.field?.toLowerCase() == "employeesrangename") {
                this.getAllEmployeesCount(fieldDetailsForm, selectedValues);
            } else if (field.field?.toLowerCase() == "annualrevenuename") {
                this.getAllAnnualRevenue(fieldDetailsForm, selectedValues);
            } else if (field.field?.toLowerCase() == "ownershipname") {
                this.getAllOwners(fieldDetailsForm, selectedValues);
            } else if (['stagename','currentstage','classificationame'].includes(field.field?.toLowerCase())) {
                this.getAllStages(fieldDetailsForm, selectedValues, this.selectedModule.objectId, this.selectedTemplate.id);
            } else if (field.field?.toLowerCase() == "timezonename") {
                this.getAllTimezones(fieldDetailsForm, selectedValues);
            } else if (field.field?.toLowerCase() == "industryname") {
                this.getAllIndustries(fieldDetailsForm, selectedValues);
            }
            else if (field.field?.toLowerCase() == 'leadtypesname') {
                this.getAllLeadTypes(fieldDetailsForm, selectedValues);
            } else if (field.field?.toLowerCase() == "leadsstatus") {
                this.getAllLeadStatus(fieldDetailsForm, selectedValues);
            } else if (field.field?.toLowerCase() == 'tags') {
                this.getAllTags(fieldDetailsForm, selectedValues);
            } else if (field.valueDataType?.toLowerCase() == "country") {
                this.getCountryByTemplateId(fieldDetailsForm, selectedValues);
            } else if (field.field?.toLowerCase() == "state") {
                this.getStatesByCountry(fieldDetailsForm, selectedValues);
            } else if (field.field?.toLowerCase() == "city") {
                this.getCityByStateList(fieldDetailsForm, selectedValues);
            } else if (field.field?.toLowerCase() == "currencyname" ||
                field.field?.toLowerCase() == "currencyunitid"
            ) {
                this.getCurrencyList(fieldDetailsForm, selectedValues);
            } else if (field.field?.toLowerCase() == "ratingname") {
                this.getAllRatings(fieldDetailsForm, selectedValues);
            } else if (field.field?.toLowerCase() == "title") {
                this.getSalutations(fieldDetailsForm, selectedValues);
            } else if (field.field?.toLowerCase() == "jobfunction") {
                this.getJobFunction(fieldDetailsForm, selectedValues);
            } else if (field.field?.toLowerCase() == "territoryname") {
                this.getAllCountryTerriList(fieldDetailsForm, selectedValues);
            } else if(['activeinactivestatus'].includes(field.field?.toLowerCase())){
                this.getActiveInActiveStatus(fieldDetailsForm, selectedValues);
            }
            else if (['contact_roles'].includes(field.field?.toLowerCase())) {
                this.loadContactRoles(fieldDetailsForm, selectedValues);
            }
        }
    }

    isNumberKey(evt) {
        var charCode = evt.which ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
        return true;
    }

    mapToNewArray(dataSet: any, mapField = 'name') {
        if (dataSet.length) {
            return dataSet.map(obj => ({
                id: Number(obj.id + ""),
                name: obj[mapField]
            }))
        }
        return [];
    }

    findInArray(filterValArr: any, optionArr: any) {
        return optionArr.filter(obj => filterValArr.find(val => val.name == obj.name));
    }

    setDropDownValue(fieldDetailsForm: FormGroup, dropDownValue: any[], selectedValues: any) {
        let dropdownValues = [];

        if (dropDownValue?.length > 0) {
            dropDownValue.map(value => {
                dropdownValues.push({
                    id: value?.id,
                    name: value?.name
                })
            })
        }

        fieldDetailsForm.patchValue({
            dropdownValues: dropdownValues
        })

        if ((typeof selectedValues) == 'object') {
            if (selectedValues?.id > 0) {
                const addedList: any = dropdownValues.find(c => c?.id == selectedValues?.id) || [];
                fieldDetailsForm.patchValue({
                    newValue: addedList
                })
            }
        } else {
            if (selectedValues?.length > 0) {
                const addedList: any[] = [];

                selectedValues.map(addedValue => {
                    const exist = dropdownValues.find(c => c?.id == addedValue?.id);

                    if (exist) {
                        addedList.push(exist);
                    }
                });

                fieldDetailsForm.patchValue({
                    newValue: addedList
                })
            }
        }

    }

    //#endregion

    //#region ***Account Module Dropdowns***
    getUsersList(fieldDetailsForm: FormGroup, selectedValues: any) {
        const dropdownValues = this.app.usersList.filter(obj => obj.statusId == 1);
        this.setDropDownValue(fieldDetailsForm, dropdownValues, selectedValues);
    }

    getCountryByTemplateId(fieldDetailsForm: FormGroup, selectedValues: any) {
        this.appMainService.isShowSpinner('LoadCountry');
        this.savedSearchesService.getAllCountryDto().subscribe(res => {
            this.appMainService.isHideSpinner('LoadCountry');
            let allCountries = [];
            if (res) {
                allCountries = res.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(fieldDetailsForm, allCountries, selectedValues);
        },
            err => {
                this.appMainService.isHideSpinner('LoadCountry');
            });
    }

    getStatesByCountry(fieldDetailsForm: FormGroup, selectedValues: any) {

        let findCountrySelected = null;

        if (findCountrySelected?.value?.id) {
            this.appMainService.isShowSpinner('loadStates');
            // this.savedSearchesService.findCountrySelected(this.selectedParentModule?.id, this.selectedParentTemplate.id, findCountrySelected?.value?.id).then(res => {
            this.savedSearchesService.getStateByMultipleCountryIdDto(findCountrySelected?.value?.id?.toString()).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(states => {
                this.appMainService.isHideSpinner('loadStates');
                let allStates = [];
                if (states) {
                    allStates = states.map(x => ({ id: x.id, name: x.name }));
                }
                this.setDropDownValue(fieldDetailsForm, allStates, selectedValues);
            },
                err => {
                    this.appMainService.isHideSpinner('loadStates');
                });
        }
    }

    getCityByStateList(fieldDetailsForm: FormGroup, selectedValues: any) {

    }

    getAllLeadTypes(fieldDetailsForm: FormGroup, selectedValues: any) {
        this.leadService.getAllLeadTypes(TypeGroupIds.LeadTypeLeadAPI).then(types => {
            let resValue = [];
            if (types) {
                types = types?.filter(x => x?.statusId == 1);
                resValue = types.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(fieldDetailsForm, resValue, selectedValues);
        });
    }
    getAllLeadStatus(fieldDetailsForm: FormGroup, selectedValues: any) {
        this.leadService.getAllLeadStatus(StatusGroupIds.LeadStatusGroupId).then(status => {
            let resValue = []
            if (status) {
                resValue = status.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(fieldDetailsForm, resValue, selectedValues);
        });
    }

    getActiveInActiveStatus(fieldDetailsForm: FormGroup,selectedValues: any) {
        let resValue = [
            {id: Status.Active, name: 'Active'},
            {id: Status.InActive, name: 'In Active'},
        ];

        this.setDropDownValue(fieldDetailsForm, resValue, selectedValues);
    }
    //Stage
    getAllStages(fieldDetailsForm: FormGroup, selectedValues: any, objectId: number, channelId: number) {
        this.ruleService.getStageList(objectId, channelId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(stages => {
            let resValue = []
            if (stages) {
                resValue = stages.filter(el => el.id && el.id !== -1).map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(fieldDetailsForm, resValue, selectedValues);
        });
    }
    //Industry
    getAllIndustries(fieldDetailsForm: FormGroup, selectedValues: any) {
        this.accountService.getAllIndustries().then(industries => {
            let resValue = []
            if (industries) {
                resValue = industries.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(fieldDetailsForm, resValue, selectedValues);
        });
    }
    //AccountSource
    getAllAccountSource(fieldDetailsForm: FormGroup, selectedValues: any) {
        this.accountService.getAllSources(this.app.user.organizationId).then(source => {
            let resValue = []
            if (source) {
                resValue = source.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(fieldDetailsForm, resValue, selectedValues);
        });
    }
    //Owners
    getAllOwners(fieldDetailsForm: FormGroup, selectedValues: any) {
        this.accountService.getAllOwnerships().then(owners => {
            let resValue = []
            if (owners) {
                resValue = owners.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(fieldDetailsForm, resValue, selectedValues);
        });
    }
    //LeadSource
    getAllLeadSource(fieldDetailsForm: FormGroup, selectedValues: any) {
        this.leadService.getAllSources(this.app.user.organizationId).then(source => {
            let resValue = []
            if (source) {
                resValue = source.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(fieldDetailsForm, resValue, selectedValues);
        });
    }
    //Currency
    getCurrencyList(fieldDetailsForm: FormGroup, selectedValues: any) {
        this.accountService.getCurrency().then(currencyList => {
            let resValue = []
            if (currencyList) {
                resValue = currencyList.map(x => ({ id: x.id, name: `${x.name} - ${x.code}` }));
            }
            this.setDropDownValue(fieldDetailsForm, resValue, selectedValues);
        });
    }
    //Timezone
    getAllTimezones(fieldDetailsForm: FormGroup, selectedValues: any) {
        this.accountService.getTimezone().then(timezoneList => {
            let resValue = []
            if (timezoneList) {
                resValue = timezoneList.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(fieldDetailsForm, resValue, selectedValues);
        });
    }
    //AnnualRevenue
    getAllAnnualRevenue(fieldDetailsForm: FormGroup, selectedValues: any) {
        this.accountService.getAllRevenues().then(revenue => {
            let resValue = []
            if (revenue) {
                resValue = revenue.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(fieldDetailsForm, resValue, selectedValues);
        });
    }
    //Rating
    getAllRatings(fieldDetailsForm: FormGroup, selectedValues: any) {
        this.fieldService.getAllRatings().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(ratings => {
            let resValue = ratings || [];
            if (ratings) {
                resValue = ratings.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(fieldDetailsForm, resValue, selectedValues);
        });
    }
    //Salutation/Title
    getSalutations(fieldDetailsForm: FormGroup, selectedValues: any) {
        this.contactService.getSalutations().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(resp => {
            let resValue = resp.filter(el => el?.isActive === true) || [];
            if (resValue) {
                resValue = resValue.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(fieldDetailsForm, resValue, selectedValues);
        });
    }
    //EmployeesRange
    getAllEmployeesCount(fieldDetailsForm: FormGroup, selectedValues: any) {
        this.leadService.getAllEmployeesCount().then(count => {
            let resValue = count.filter(el => el.statusId === 1);
            if (resValue) {
                resValue = resValue.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(fieldDetailsForm, resValue, selectedValues);
        });
    }
    //JobFunction
    getJobFunction(fieldDetailsForm: FormGroup, selectedValues: any) {
        this.configService.getContactRoles().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(jobFunctions => {
            let resValue = []
            if (jobFunctions) {
                resValue = jobFunctions.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(fieldDetailsForm, resValue, selectedValues);
        });
    }

    getAllCountryTerriList(fieldDetailsForm: FormGroup, selectedValues: any) {

    }

    getAllAccountTypes(fieldDetailsForm: FormGroup, selectedValues: any) {
        this.ruleService.getAllAccountTypes(AccountGroupId.ID).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(types => {
            let resValue = [];
            if (types) {
                types = types?.filter(x => x?.statusId == 1);
                resValue = types.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(fieldDetailsForm, resValue, selectedValues);
        }, err => {
        });
    }

    getAllTags(fieldDetailsForm: FormGroup, selectedValues: any) {
        this.ruleService.getAllTags().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(tags => {
            let resValue = [];
            if (tags) {
                tags = tags?.filter(x => x?.statusId == 1);
                resValue = tags.map(x => ({ id: x.id, name: x.name }));
            }
            this.setDropDownValue(fieldDetailsForm, resValue, selectedValues);
        }, err => {
        });
    }

    //#endregion

    //#region ***Manual Selection***

    assignData() {
        this.chooseAccountCol();
        this.selectedRecordList = JSON.parse(JSON.stringify(this.selectedAccounts));
        this.displayManualPopup = true;
    }

    chooseAccountCol() {
        this.columnSettingsService.getColumnSettings(this.selectedModule.id, this.selectedChannel?.id).subscribe(
            resp => {
                let defaultColumnSettings: Partial<ColumnSettingsN> = ParseHelper.DeepCopy(resp);
                if (this.manualRuleColumnSetttings != null && this.manualRuleColumnSetttings?.listViewSections?.length > 0) {
                    syncColumnSettings(this.manualRuleColumnSetttings, defaultColumnSettings);
                    this.manualRuleColumnSetttings = defaultColumnSettings
                } else {
                    this.manualRuleColumnSetttings = defaultColumnSettings;
                }
                this.setAccountColumns(this.manualRuleColumnSetttings);
            },
            err => {
            }
        );

    }

    manualpopupCancelClicked() {
        this.displayManualPopup = false;
    }

    saveAssignData($event) {
        this.selectedAccounts = JSON.parse(JSON.stringify($event.selectedReccords));
        this.accountColLists = $event.listCols;
        this.selectedRecordList = JSON.parse(JSON.stringify($event.selectedReccords));
        this.displayManualPopup = false;
    }

    columnSettingSaved($event) {
        this.manualRuleColumnSetttings = $event;
        this.setAccountColumns(this.manualRuleColumnSetttings);
    }

    setAccountColumns(columnSettings: Partial<ColumnSettingsN>) {
        this.accountColLists = getSectionWiseFlatCols(columnSettings.listViewSections);
    }

    //#endregion

    //#region ***Rules Selection***

    newParentRule(s) {
        this.conditionTemp = ParseHelper.DeepCopy(s);
        this.ruleData = ParseHelper.DeepCopy(s.ruleData);
        this.lastRuleValues = {
            ...this.lastRuleValues,
            selectedFilter: null,
            selectedOperator: null,
            selectedValue: null,
            selectedValue2: null,
            selectedChoice: this.ruleData.length > 1 ? this.ruleData[1].choice : { id: 1, name: "And" },
            compareWithField: false,
            comparisonCriteria: null,
            customAttributeObjectId: null,
            comparisonCustomAttributeObjectId: null,
            comparisonCriteriaLabel: null,
            comparisonCriteriaParentLabel: null,
            isCustomComparisonCriteria: false,
            comparisonCriteriaObject: null,
        };
        this.displayParentNewRule = true;
    }

    saveRule() {

        if (!this.validateRuleError()) {
            return;
        }

        let lastSelectedChoice: any = { id: 1, name: "And" };

        //Parent Rules
        let parentRule = this.ruleData.filter(ele => ele.isMainModule == true);

        if (this.ruleList.length > 0) {
            for (let s of this.ruleList) {
                if (s?.filter?.parent || s?.filter?.children) {
                    s.filter.parent = null;
                    s.filter.children = null;
                }
                s.valueLists = [];
                s.filtersDD = [];
                s.treeValueLists = [];
                s.filtersDDTree = [];
                s.ruleNo = !s?.ruleNo ? savedSearchRuleNo([...parentRule]) : s.ruleNo;
                parentRule.push(s);
            }
            lastSelectedChoice = this.ruleList[(this.ruleList.length - 1)].choice || lastSelectedChoice;
        }

        const parentRuleNo = savedSearchRuleNo([...parentRule]);
        const lastMainRule = this.setLastRuleValue(this.lastRuleValues,true,parentRuleNo);

        if (lastMainRule) {
            parentRule.push(lastMainRule);
            lastSelectedChoice = lastMainRule.choice || lastSelectedChoice;
        }

        this.ruleData = [];
        for (let a of parentRule) {
            a.choice = a.choice ?? { id: 1, name: "And" };
            this.ruleData.push(a);
        }

        for (let rule of this.ruleData) {
            // rule.choice = lastSelectedChoice;
            rule = getSavedSearchTreeRuleValues(rule);
        }

        if (this.ruleData.length > 0) {
            this.ruleData[0].choice = null;
        }

        this.ruleList = [];
        //Country,State,City rule edit enable/disable
        this.setCanEdit(this.ruleData);
        const selectedCondtion = this.conditionGroup;

        if (selectedCondtion) {
            selectedCondtion.type = 'manual';
            selectedCondtion.ruleData = ParseHelper.DeepCopy(this.ruleData);
            this.ruleData = [];
        }

        this.displayParentNewRule = false;
    }

    updateEditedRule() {
        if (!this.validateRuleError()) {
            return;
        }
        const selectedCondtion = this.conditionGroup;
        if (selectedCondtion.type != 'manual') {
            selectedCondtion.type = 'manual';
            selectedCondtion.savedSearchId = 0;
        }
        if (selectedCondtion.ruleData.length > this.selectedRuleIndex) {
            const editedRuleData = this.setEditedRuleValue(this.lastRuleValues);
            if (editedRuleData) {
                selectedCondtion.ruleData[this.selectedRuleIndex] = editedRuleData;
                selectedCondtion['editedRuleData'] = editedRuleData;

                // selectedCondtion.ruleData.map(rule => {
                //     rule.choice = selectedCondtion.ruleData[this.selectedRuleIndex].choice
                // })

                selectedCondtion.ruleData[0].choice = null;
                this.setCanEdit(selectedCondtion.ruleData);
                this.displayEditRule = false;
            }
        }
    }

    updateRuleChoice(addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup, data: {ruleIndex: number, choice: SavedSearchNS.IChoice}){
        addedCondition.ruleData[data.ruleIndex].choice = data.choice;
    }

    setLastRuleValue(lastRuleValue: any, isMainModule, ruleNo: string) {
        if (lastRuleValue.selectedFilter && ((lastRuleValue.selectedValue || lastRuleValue.selectedDataTypeWithOperator?.NoOfValuesToBePassed == 'No_Value') || (['Money', 'Number', 'Decimal'].includes(lastRuleValue.selectedFilter?.fieldDataType) && lastRuleValue.selectedValue !== null) ||
            (lastRuleValue.selectedFilter?.fieldDataType == 'DateTime' && lastRuleValue.selectedDataTypeWithOperator?.Operator == 'Is' && lastRuleValue.selectedValue2))) {
            let eachRule: SavedSearchNS.IRuleList = {
                id: 0,
                ruleNo: ruleNo,
                module: this.selectedModule,
                subModule: null,
                template: this.selectedTemplate,
                filter: lastRuleValue.selectedFilter,
                operator: lastRuleValue.selectedOperator,
                value: lastRuleValue.selectedValue,
                value2: lastRuleValue.selectedValue2,
                choice: lastRuleValue.selectedChoice,
                isMainModule: isMainModule,
                dataTypeWithOperator: lastRuleValue.selectedDataTypeWithOperator,
                valueLists: [],
                treeValueLists: [],
                objectId: this.selectedModule?.objectId,
                objectName: this.selectedModule?.name,
                valueRefId: [],
                groupLabel: lastRuleValue.selectedGroupLabel,
                groupChildren: lastRuleValue.selectedGroupChildren,
                group: lastRuleValue.selectedGroup,
                filtersDD: [],
                canEdit: true,
                accountChannel: null,
                compareWithField: lastRuleValue?.compareWithField||false,
                comparisonCriteria: lastRuleValue?.comparisonCriteria||null,
                customAttributeObjectId: lastRuleValue?.customAttributeObjectId,
                comparisonCustomAttributeObjectId: lastRuleValue?.comparisonCustomAttributeObjectId,
                comparisonCriteriaLabel: lastRuleValue?.comparisonCriteriaLabel||null,
                comparisonCriteriaParentLabel: lastRuleValue?.comparisonCriteriaParentLabel||null,
                isCustomComparisonCriteria: lastRuleValue?.isCustomComparisonCriteria||false,
                comparisonCriteriaObject: this.selectedModule?.name||null,
            }
            if (eachRule?.filter?.parent || eachRule?.filter?.children) {
                eachRule.filter.parent = null;
                eachRule.filter.children = null
            }

            return eachRule;
        }

        return null;
    }

    setEditedRuleValue(lastRuleValue: any) {
        if (lastRuleValue.selectedFilter && ((lastRuleValue.selectedValue || lastRuleValue.selectedDataTypeWithOperator?.NoOfValuesToBePassed == 'No_Value') || (['Money', 'Number', 'Decimal'].includes(lastRuleValue.selectedFilter?.fieldDataType) && lastRuleValue.selectedValue !== null) ||
            (lastRuleValue.selectedFilter?.fieldDataType == 'DateTime' && lastRuleValue.selectedDataTypeWithOperator?.Operator == 'Is' && lastRuleValue.selectedValue2))) {
            let eachRule: SavedSearchNS.IRuleList = {
                ...this.selectedEditedRule,
                filter: lastRuleValue.selectedFilter,
                operator: lastRuleValue.selectedOperator,
                value: lastRuleValue.selectedValue,
                value2: lastRuleValue.selectedValue2,
                choice: lastRuleValue.selectedChoice,
                dataTypeWithOperator: lastRuleValue.selectedDataTypeWithOperator,
                valueLists: [],
                treeValueLists: [],
                valueRefId: [],
                groupLabel: lastRuleValue.selectedGroupLabel,
                groupChildren: lastRuleValue.selectedGroupChildren,
                group: lastRuleValue.selectedGroup,
                filtersDD: [],
                compareWithField: lastRuleValue?.compareWithField||false,
                comparisonCriteria: lastRuleValue?.comparisonCriteria||null,
                customAttributeObjectId: lastRuleValue?.customAttributeObjectId,
                comparisonCustomAttributeObjectId: lastRuleValue?.comparisonCustomAttributeObjectId,
                comparisonCriteriaLabel: lastRuleValue?.comparisonCriteriaLabel||null,
                comparisonCriteriaParentLabel: lastRuleValue?.comparisonCriteriaParentLabel||null,
                isCustomComparisonCriteria: lastRuleValue?.isCustomComparisonCriteria||false
            }
            eachRule = getSavedSearchTreeRuleValues(eachRule);
            if (eachRule?.filter?.parent || eachRule?.filter?.children) {
                eachRule.filter.parent = null;
                eachRule.filter.children = null
            }

            return eachRule;
        }

        return null;
    }

    removeRule(ruleData: any[], ruleDetails: { rule: any, index: number }) {
        ruleData.splice(ruleDetails.index, 1);
        this.setCanEdit(ruleData);
        this.ruleData = ruleData;
    }

    editRule(addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup, ruleDetails: { rule: any, index: number }) {
        this.conditionTemp = ParseHelper.DeepCopy(addedCondition);
        this.ruleData = ParseHelper.DeepCopy(addedCondition.ruleData);
        this.selectedEditedRule = ParseHelper.DeepCopy(ruleDetails.rule);
        addedCondition['editedRuleData'] = null;
        this.selectedRuleIndex = ruleDetails.index;
        this.displayEditRule = true;
    }

    saveRuleCombination(addedCondition: WorkflowModelsNS.WorkflowAddedEditConditionGroup, data: {isCombinational: boolean, ruleCombination: string}){
        addedCondition.isCombinational = data.isCombinational;
        addedCondition.ruleCombination = data.ruleCombination;
    }

    cancelEditRule() {
        this.displayEditRule = false;
    }

    cancelParentRuleDialog() {
        this.ruleList = [];
        this.displayParentNewRule = false;
    }

    //Country,State,City rule edit enable/disable
    setCanEdit(ruleData: SavedSearchNS.IRuleList[]) {
        //Set Rule Edit Enable/Disable
        for (let rule of ruleData) {
            rule.canEdit = this.canRuleEdit(rule.filter, ruleData);
        }
        //Remove first choice
        if (ruleData?.length > 0) {
            ruleData[0].choice = null;
        }
    }

    canRuleEdit(filter: SavedSearchNS.IField, ruleData: SavedSearchNS.IRuleList[]): boolean {
        let canRuleEdit = true;
        if (filter &&
            (filter?.field?.toLowerCase() == "country" ||
                filter?.field?.toLowerCase() == "state" ||
                filter?.field?.toLowerCase() == "city")) {

            const country = ruleData.find(x => x.filter.field?.toLowerCase() == "country");
            const state = ruleData.find(x => x.filter.field?.toLowerCase() == "state");
            const city = ruleData.find(x => x.filter.field?.toLowerCase() == "city");
            //Country
            if (filter?.field?.toLowerCase() == "country") {
                if (state) {
                    canRuleEdit = false;
                }
            }
            //State
            else if (filter?.field?.toLowerCase() == "state") {
                if (city) {
                    canRuleEdit = false;
                }
            }
            //City
            else if (filter?.field?.toLowerCase() == "city") {
                canRuleEdit = true;
            }

        }

        if (filter && ['trans_location_country','trans_location_state'].includes(filter?.field?.toLowerCase())) {
            const trans_location_state = ruleData.find(x => x.filter.field?.toLowerCase() == "trans_location_state");
            const trans_location_city = ruleData.find(x => x.filter.field?.toLowerCase() == "trans_location_city");

            if ((filter?.field?.toLowerCase() == "trans_location_country" && trans_location_state)
                ||(filter?.field?.toLowerCase() == "trans_location_state" && trans_location_city)) {
                canRuleEdit = false;
            }
        }

        if (filter && ['opportunity_country','opportunity_state'].includes(filter?.field?.toLowerCase())) {
            const opportunity_state = ruleData.find(x => x.filter.field?.toLowerCase() == "opportunity_state");
            const opportunity_city = ruleData.find(x => x.filter.field?.toLowerCase() == "opportunity_city");

            if ((filter?.field?.toLowerCase() == "opportunity_country" && opportunity_state)
                ||(filter?.field?.toLowerCase() == "opportunity_state" && opportunity_city)) {
                canRuleEdit = false;
            }
        }

        return canRuleEdit;
    }

    validateRuleError() {
        const invalidField = document.querySelector('.saved-search-rule-error');
        const classList = invalidField?.classList ? Array.from(invalidField.classList) : [];
        let valid: boolean = true;
        if (classList?.length > 0) {
            valid = false;
        }

        return valid;
    }

    //#endregion

    scrollToError(): void {
        const firstElementWithError = document.querySelector('.ng-invalid[formControlName]');
        this.scrollTo(firstElementWithError);

        if (!firstElementWithError) {
            const secondElementWithError = document.querySelector('.p-invalid');
            this.scrollTo(secondElementWithError);
        }
    }

    // Scroll to error element
    scrollTo(el: Element): void {
        if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }

    resetData() {

        let message = "Are you sure want to clear added rules?";
        let header = "Clear added Rules?";

        if(this.selectedRuleOption == 'manually'){
            message = `Are you sure want to clear added ${this.selectedModuleName}s?`;
            header = `Clear added  ${this.selectedModuleName}s?`;
        }

        this.confirmationService.confirm({
            message: message,
            header: header,
            icon: 'pi pi-info-circle',
            accept: () => {
                this.selectedAccounts = [];
                this.selectedRecordList = [];
                this.ruleData = [];
                this.conditionGroup.ruleData = [];
            },
            reject: () => { }
        });
    }

    closeMassEditDialog() {
        this.closeDialog.emit(true);
    }

    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }

    //#region ***Add Expression***

    updatedAddedTags(value: string, fieldDetailsForm: FormGroup){
        const addedFieldTags = [];
        if(value){
            const addedTags: string[] = value.match(customFieldTagRegex)||[];

            addedTags.map(labelName=>{
                const exist = this.availableFieldsForExpression.find(field=>field.labelname.trim()==labelName.trim());

                if(exist){
                    if(!addedFieldTags.includes(exist.labelname))
                        addedFieldTags.push(exist.labelname);
                }
            })

            fieldDetailsForm.patchValue({
                addedFieldTags: addedFieldTags
            });
        }
    }

    fieldDetailsForm: FormGroup = null;

    openExpressionAdd(fieldDetailsForm: FormGroup){
        this.expressionText = "";
        this.fieldDetailsForm = fieldDetailsForm;
        if(this.fieldDetailsForm.value.fieldValueType== WorkflowModelsNS.WorkflowUpdateFieldValueType.Expression && this.fieldDetailsForm.value.newValue){
            this.expressionText = this.fieldDetailsForm.value.newValue;
        }

        this.displayAddExpression = true;
    }

    saveExpression(expressionData: {expressionText: string, addedFieldTags: string[]}){
        if(this.fieldDetailsForm){
            this.fieldDetailsForm.patchValue({
                newValue: expressionData.expressionText,
                fieldDataType: 'String',
                fieldValueType: WorkflowModelsNS.WorkflowUpdateFieldValueType.Expression
            });
            this.updatedAddedTags(expressionData.expressionText, this.fieldDetailsForm);
        }
    }

    removeExpression(fieldDetailsForm: FormGroup){
        fieldDetailsForm.patchValue({
            fieldValueType: WorkflowModelsNS.WorkflowUpdateFieldValueType.Value
        });

        this.setSectionCustomPayload(fieldDetailsForm);
    }

    expressionDialogClose(){
        this.displayAddExpression = false;
    }

    //#endregion ***Add Expression***

    isPatternInvalid(form: FormGroup, formControlName: string): boolean {
        const control = form?.get(formControlName);
        return control.hasError('pattern') && control?.touched;
    }

    changeHistoryTab($event: any){
        this.historySearchControl.patchValue("");
    }

    initHistorySearch() {
        this.historySearchControl.valueChanges.pipe(
            debounceTime(700),
            distinctUntilChanged())
            .subscribe((value: string) => {
                this.historySearchValue = value.trim() || '';
            });
    }

    refreshHistory(){
        this.historyRefresh = true;
        setTimeout(()=>{
            this.historyRefresh = false;
        })
    }

    loadContactRoles(fieldDetailsForm: FormGroup, selectedValues: any): void {
             this.appMainService.isShowSpinner('contactRoles');
             this.configService.getNewAllContactRoles().subscribe({
             next: (resp: any[]) => {
                let contactRoles :any = resp?.length ? resp : [];
                contactRoles = contactRoles.map(x => ({ id: x.id, name: x.name }));
                this.setDropDownValue(fieldDetailsForm, contactRoles, selectedValues);
                this.appMainService.isHideSpinner("contactRoles");
             },
             error: (err) => {
                 this.appMainService.isHideSpinner('contactRoles');
             }
             });
    }

}

